module.exports = __webpack_public_path__ + "static/assets/a299dfce333bc76558e0bd663bddf0c9.gif";